import { createSlice } from "@reduxjs/toolkit";
import { DxDataGridColumn } from "../shared/models/DxDataGridColumn";

const initialState = {
  reviewProductionIndicesColumns: [] as DxDataGridColumn[],
  reviewProductionIndicesDataSource: [] as any[],
};

const productionSlice = createSlice({
  name: "production",
  initialState: initialState,
  reducers: {
    setReviewProductionIndicesColumns(state, action) {
      state.reviewProductionIndicesColumns = action.payload;
    },
    setReviewProductionIndicesDataSource(state, action) {
      state.reviewProductionIndicesDataSource = action.payload;
    },
  },
});

export const {
  setReviewProductionIndicesColumns,
  setReviewProductionIndicesDataSource,
} = productionSlice.actions;
export const productionReducer = productionSlice.reducer;

// Selector
export const selectReviewProductionIndicesColumns = (state: any) =>
  state.production.reviewProductionIndicesColumns as DxDataGridColumn[];
export const selectReviewProductionIndicesDataSource = (state: any) =>
  state.production.reviewProductionIndicesDataSource;
